import { ButtonWithConfirmation } from 'framework/ui/ui-builder';
import React from 'react';
import { Box } from '@mui/material';
import { useFieldHelper } from 'framework/ui/field';
import { getClientPortalUserActionLabel, getClientPortalUserConfirmationMessage } from './constants';
import { CLIENT_PORTAL_USER_STATUSES } from 'domain/shared/clientPortal';
import useAccountManagementService from '../useAccountManagementService';
import { Data } from 'framework/types';

const ClientPortalActivateUser = ({
  statusSource,
  account,
  userIdSource,
  onSubmitSuccess,
}: {
  statusSource: string;
  account: Data;
  userIdSource: string;
  onSubmitSuccess: () => void;
}) => {
  const { getValue: getStatusValue } = useFieldHelper<string>({ source: statusSource });
  const { getValue: getUserIdValue } = useFieldHelper<string>({ source: userIdSource });
  const status = getStatusValue();
  const userId = getUserIdValue();
  const actionLabel = getClientPortalUserActionLabel(status);
  const { revokePortalInvitation, activatePortalUser, deactivatePortalUser } = useAccountManagementService();

  if (status === CLIENT_PORTAL_USER_STATUSES.FAILED) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
      <ButtonWithConfirmation
        variant={'text'}
        submitMethod={() => {
          if (status === CLIENT_PORTAL_USER_STATUSES.INVITED) {
            return revokePortalInvitation(account.accountId, userId);
          } else if (status === CLIENT_PORTAL_USER_STATUSES.INACTIVE) {
            return activatePortalUser(account.accountId, userId);
          } else {
            return deactivatePortalUser(account.accountId, userId);
          }
        }}
        displayMessage={getClientPortalUserConfirmationMessage(status)}
        modalConfirmButtonText={
          status === CLIENT_PORTAL_USER_STATUSES.INVITED
            ? 'Revoke'
            : status === CLIENT_PORTAL_USER_STATUSES.INACTIVE
              ? 'Activate'
              : 'Deactivate'
        }
        afterSubmit={{
          execute: onSubmitSuccess,
        }}
      >
        {actionLabel}
      </ButtonWithConfirmation>
    </Box>
  );
};
export default ClientPortalActivateUser;
